import React from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, List } from 'react-virtualized';
import { Document, Page } from 'react-pdf';

export const PdfViewer = ({ pdfFile, handleLoadedDocumentLoadSuccess, handleScroll, pdfSettings }) => {
    const rowRenderer = ({ key, index, style }) => (
        <span key={key} style={style}>
            <Page
                scale={pdfSettings.scale}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                loading=""
                pageNumber={index + 1}
            />
        </span>
    );

    return (
        <AutoSizer>
            {({ height, width }) => (
                <>
                    {!!width && width > 0 && (
                        <Document
                            file={pdfFile}
                            loading=""
                            onLoadSuccess={pdfObject => handleLoadedDocumentLoadSuccess(pdfObject, width)}
                        >
                            {pdfSettings.numPages && (
                                <List
                                    height={height}
                                    rowCount={pdfSettings.numPages}
                                    rowHeight={pdfSettings.pageHeight}
                                    rowRenderer={rowRenderer}
                                    width={width}
                                    overscanRowCount={1}
                                    onScroll={handleScroll}
                                />
                            )}
                        </Document>
                    )}
                </>
            )}
        </AutoSizer>
    );
};

PdfViewer.propTypes = {
    pdfFile: PropTypes.func,
    handleLoadedDocumentLoadSuccess: PropTypes.func,
    handleScroll: PropTypes.func,
    pdfSettings: PropTypes.object,
};
